/**
 * Spotlight-style search overlay with live typeahead.
 * Registered as an Alpine component and opened via a window `open-search` event.
 */
export function registerSearchSpotlight(Alpine) {
    Alpine.data('searchSpotlight', () => ({
        isOpen: false,
        query: '',
        results: [],
        total: 0,
        loading: false,
        activeIndex: -1,
        _controller: null,

        open() {
            this.isOpen = true;
            document.body.style.overflow = 'hidden';
            this.$nextTick(() => this.$refs.input && this.$refs.input.focus());
        },

        close() {
            if (!this.isOpen) return;
            this.isOpen = false;
            document.body.style.overflow = '';
            if (this._controller) {
                this._controller.abort();
                this._controller = null;
            }
        },

        async fetchResults() {
            const q = this.query.trim();
            this.activeIndex = -1;

            if (q.length < 2) {
                this.results = [];
                this.total = 0;
                this.loading = false;
                return;
            }

            this.loading = true;

            // Cancel any in-flight request so results never arrive out of order.
            if (this._controller) this._controller.abort();
            this._controller = new AbortController();

            try {
                const res = await fetch('/api/suche/suggest?q=' + encodeURIComponent(q), {
                    headers: { Accept: 'application/json' },
                    signal: this._controller.signal,
                });
                if (!res.ok) throw new Error('Suggest request failed: ' + res.status);

                const data = await res.json();
                this.results = data.results || [];
                this.total = data.total || 0;
            } catch (e) {
                if (e.name !== 'AbortError') {
                    this.results = [];
                    this.total = 0;
                }
            } finally {
                this.loading = false;
            }
        },

        move(direction) {
            if (!this.results.length) return;
            const count = this.results.length;
            this.activeIndex = (this.activeIndex + direction + count) % count;
        },

        enter() {
            if (this.activeIndex >= 0 && this.results[this.activeIndex]) {
                window.location.href = this.results[this.activeIndex].url;
                return;
            }
            const q = this.query.trim();
            if (q.length) {
                window.location.href = '/suche?q=' + encodeURIComponent(q);
            }
        },

        allResultsUrl() {
            return '/suche?q=' + encodeURIComponent(this.query.trim());
        },
    }));
}
